<script setup lang="ts">
import TextLabel from "@/components/UI/TextLabel.vue";
interface Props {
	severity?: 'notice'|'error';
}
const props = defineProps<Props>();

const cssClasses = () => {
	const classes = [
		'text-notice'
	];

	if (props.severity) {
		classes.push(`text-notice--${props.severity}`);
	}

	return classes;
};

</script>

<template>
	<div :class="cssClasses()">
		<div v-if="$slots.icon" class="text-notice__icon" >
			<slot name="icon"></slot>
		</div>
		<text-label>
			<slot></slot>
		</text-label>
	</div>
</template>

<style scoped lang="scss">
.text-notice {
	display: flex;
	gap: 5px;
	flex-direction: row;
	flex-wrap: nowrap;

	&--notice {
		color: $brand-blue-dark;
	}

	&--error {
		color: $error-color;
	}

	&:deep(.text-label) {
		line-height: 1.333;
	}

	&__icon {
		display: inline-flex;
		align-items: flex-start;
		width: 20px;
		padding: 4px;
		flex-shrink: 0;

		&:deep(svg) {
			width: 100%;
			height: auto;
		}
	}
}
</style>
